import React, { useEffect, type ReactNode } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.js';
import { AppErrorBoundary } from './components/AppErrorBoundary.js';
import { routerFutureConfig } from './lib/router-future.js';
import { installGlobalStartupRecovery, showStartupRecovery } from './lib/startup-recovery.js';
import { installNativePurchaseUpdateListener } from './lib/subscription.js';
import './styles/global.css';

installGlobalStartupRecovery();
installNativePurchaseUpdateListener();

try {
  const root = document.getElementById('root');
  if (!root) throw new Error('Truebend root element is missing');

  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <StartupFallbackController>
        <BrowserRouter future={routerFutureConfig}>
          <AppErrorBoundary>
            <App />
          </AppErrorBoundary>
        </BrowserRouter>
      </StartupFallbackController>
    </React.StrictMode>,
  );
} catch (error) {
  console.error('Truebend failed before React could start', error);
  showStartupRecovery();
}

function StartupFallbackController({ children }: { children: ReactNode }) {
  useEffect(() => {
    document.getElementById('startup-fallback')?.remove();
  }, []);

  return <>{children}</>;
}
